import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import GetPrice from "../Functions/GetPrice";
import {
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  RangeToFa,
  capitalizeFirstLetters,
} from "../Functions/TextTransform";
import { DebounceInput } from "react-debounce-input";
import OverlayContainer from "../Components/OverlayContainer";
import {
  Accordion,
  AccordionContext,
  useAccordionButton,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import NumberToPersianWord from "number_to_persian_word";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import InnerImageZoom from "react-inner-image-zoom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useMediaQuery } from "react-responsive";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import RenderSideCart from "../Components/RenderSideCart";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import StaticMeasureHelps from "../Static Files/StaticMeasureHelps";
import { ShowLogin2Modal } from "../Actions/types";
import QtyCountFabric from "../Components/QtyCountFabric";
import { baseURLCats, baseURLCatProduct, baseURLAddProduct, baseURLSaveProduct, baseURLFreeShipping, baseURLGetFavorites, baseURLDeleteFavorite, imgUrl, baseURLGetPrice, baseURLJoinWaitingList } from "../config/api";

function NecessaryOrdering() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { catID } = useParams();
  const inputs = useRef({});
  const { productID } = useParams();
  const { designID } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLoggedIn, sideCartPrice, cartUpdated, mainCart } = useSelector((state) => state.auth);
  const [diameters, setDiameters] = useState([]);
  const [completePageState, setCompletePageState] = useState(searchParams.get("C"));
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialDiameters, setInitialDiameters] = useState([]);
  const [selectedDiameter, setSelectedDiameter] = useState(null);
  const [isWidthSelected, setIsWidthSelected] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isPriceSelected, setIsPriceSelected] = useState(false);
  const [modals, setModals] = useState({});
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const splideRef = useRef(null);
  const [catObject, setCatObject] = useState({});
  const [productAwaitingLogin, setProductAwaitingLogin] = useState([]);
  const [catProducts, setCatProducts] = useState([]);
  const [userFavorites, setUserFavorites] = useState([]);
  const [designProducts, setDesignProducts] = useState({});
  const [activeProduct, setActiveProduct] = useState({});
  const [splidesList, setSplidesList] = useState([]);
  const [slidesList, setSlidesList] = useState([]);
  const [colorsList, setColorsList] = useState([]);
  const [showError, setShowError] = useState(false);
  const [IsDiscPriceSelected, setIsDiscPriceSelected] = useState(false);
  const [isPageComplete, setIsPageComplete] = useState(completePageState === "1");
  const [isColorSelected, setIsColorSelected] = useState(true);
  const [isProductAdded, setIsProductAdded] = useState(false);
  const [colorError, setColorError] = useState(false);
  const [qty, setQty] = useState(1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [removingLoading, setRemovingLoading] = useState(false);
  const [toastSave, setToastSave] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [showWaitlistEmail, setShowWaitlistEmail] = useState(false);
  const [waitlistEmail, setWaitlistEmail] = useState("");
  const [waitlistEmailError, setWaitlistEmailError] = useState("");
  const [waitlistMessageType, setWaitlistMessageType] = useState("error");
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const waitlistMessageTimeoutRef = useRef(null);
  const [productGroupId, setProductGroupId] = useState(null);
  const [width, setWidth] = useState(undefined);
  const [minDiscountedPrice, setMinDiscountedPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [minDiscountedPrice2, setMinDiscountedPrice2] = useState(null);
  const [numberDiameter, setNumberDiameter] = useState(activeProduct["Diameter"] || null);
  const latestLenPriceRequestRef = useRef(null);

  const stockQty = Number(activeProduct["StockQty"]) || 0;
  const maxOrderableQty = Number(activeProduct["MaxOrderableQty"]) || 10;
  const fabricSteps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
  const isSoldOut = stockQty === 0 && activeProduct["OnBasket"] === false;
  const isWaitlist = stockQty === 0 && activeProduct["OnBasket"] === true;
  const fabricMaxQty =
    stockQty > 0 ? Math.round((stockQty + fabricSteps) * 100) / 100 : maxOrderableQty;
  const isOverStock = stockQty > 0 && !isSoldOut && !isWaitlist && qty > stockQty;

  const validateWaitlistEmail = (email) =>
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/.test(
      email
    );

  const showWaitlistMessage = (message, type = "error") => {
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
    }
    setWaitlistMessageType(type);
    setWaitlistEmailError(message);
    waitlistMessageTimeoutRef.current = setTimeout(() => {
      setWaitlistEmailError("");
      waitlistMessageTimeoutRef.current = null;
    }, 5000);
  };

  const isAlreadyRegisteredMessage = (message = "") =>
    /قبلاً|قبلا|already registered|already|لیست انتظار ثبت/i.test(message);

  useEffect(() => {
    return () => {
      if (waitlistMessageTimeoutRef.current) {
        clearTimeout(waitlistMessageTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setShowWaitlistEmail(false);
    setWaitlistEmail("");
    setWaitlistEmailError("");
    setWaitlistMessageType("error");
    if (waitlistMessageTimeoutRef.current) {
      clearTimeout(waitlistMessageTimeoutRef.current);
      waitlistMessageTimeoutRef.current = null;
    }
    const stock = Number(activeProduct["StockQty"]) || 0;
    const steps = activeProduct["UnitId"] === 1 ? 0.5 : 1;
    const nextMax =
      stock > 0
        ? Math.round((stock + steps) * 100) / 100
        : Number(activeProduct["MaxOrderableQty"]) || 10;
    setQty((prev) => Math.min(Math.max(prev, 1), nextMax > 0 ? nextMax : 1));
  }, [activeProduct["ProductId"]]);

  const fetchPriceByLength = async (len, productId) => {
    if (len == null || !productId) return;
    const digitCount = String(len).length;
    if (digitCount !== 2 && digitCount !== 3) return;

    latestLenPriceRequestRef.current = len;
    try {
      const response = await axios.get(baseURLGetPrice, {
        params: {
          ProductId: productId,
          len,
        },
      });
      if (latestLenPriceRequestRef.current !== len) return;

      const price = parseInt(response.data);
      if (isNaN(price)) return;

      setActiveProduct((prev) => ({
        ...prev,
        Price: price,
        DiscountedPrice: price,
        len,
      }));
      setIsPriceSelected(true);
      setIsDiscPriceSelected(true);
    } catch (err) {
      console.log(err);
    }
  };

  const getCatProducts = () => {
    if (searchParams.get("Product") && searchParams.get("Product") !== "") {
      axios
        .get(baseURLCats, {
          params: {
            pageName: catID,
            // apiKey: window.$apikey
          },
        })
        .then((response) => {
          setCatObject(response.data || {});
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
      // console.log(defDesign);
      axios
        .get(baseURLCatProduct, {
          params: {
            groupId: productID,
            designs: designID,
            // apiKey: window.$apikey
          },
        })
        .then((response) => {
          if (response.data && response.data["Products"].length) {
            setCatProducts(response.data["Products"]);
          } else {
            setCatProducts({});
            setDesignProducts({});
            navigate("/" + pageLanguage);
          }
        })
        .catch((err) => {
          console.log(err);
          navigate("/" + pageLanguage);
        });
    } else {
      navigate("/" + pageLanguage);
    }
  };

  function getFavorites() {
    axios
      .get(baseURLGetFavorites, {
        headers: authHeader(),
      })
      .then((response) => {
        if (isLoggedIn && !response.data?.length && productAwaitingLogin.length) {
          saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
          setProductAwaitingLogin([]);
        }
        setUserFavorites(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getFavorites();
            } else {
              // navigate("/" + pageLanguage);
            }
          });
        } else {
          setUserFavorites([]);
        }
      });
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function getActiveColorProducts() {
    let tempActiveProduct =
      catProducts.find((obj) => obj["ProductId"] === searchParams.get("Product")) || {};

    if (Object.keys(tempActiveProduct).length === 0) {
      navigate("/" + pageLanguage);
    } else {
      let tempColorProduct = {};
      let promiseArr = [];
      catProducts.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          if (
            tempColorProduct[obj["ColorId"]] === "" ||
            tempColorProduct[obj["ColorId"]] === undefined ||
            tempColorProduct[obj["ColorId"]] === null ||
            tempColorProduct[obj["ColorId"]].length === 0
          ) {
            tempColorProduct[obj["ColorId"]] = [];
          }
          tempColorProduct[obj["ColorId"]].push(obj);
          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setDesignProducts(tempColorProduct);

        setActiveProduct(tempActiveProduct);
      });
    }
  }

  const result = {};

  Object.values(designProducts).forEach((group) => {
    group.forEach((product) => {
      const { ColorEnName, Diameter } = product;

      if (!result[ColorEnName]) {
        result[ColorEnName] = [];
      }

      if (!result[ColorEnName].includes(Diameter)) {
        result[ColorEnName].push(Diameter);
      }
    });
  });

  function renderPageContent() {
    if (Object.keys(designProducts).length) {
      let tempColorProduct = [];
      let tempImgProduct = [];
      let tempItemImgProduct = [];
      let promiseArr = [];
      Object.keys(designProducts).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let ProductId = designProducts[key][0]["ProductId"];
          let ColorProductGroupId = designProducts[key][0]["ProductGroupId"];
          setProductGroupId(ColorProductGroupId);
          let ColorEnName = CapitalizeAllWords(designProducts[key][0]["ColorEnName"]);
          let ColorName = convertToPersian(designProducts[key][0]["ColorName"]);
          let ColorPhotoPath =
            designProducts[key][0]["Photos"].find((obj) => obj.PhotoTypeId === 4709)?.PhotoUrl ||
            "";
          let isActiveColor = designProducts[key]
            .map(function(obj) {
              return obj["ProductId"];
            })
            .filter((n) => n)
            .includes(searchParams.get("Product"));
          tempColorProduct.push(
            <li
              key={"color" + ProductId + index}
              className={`rmd_info_colors_list_item Accessories_List_item_colors_list_item ${
                isColorSelected && isActiveColor ? "colorSelected" : ""
              }`}
              onClick={() => {
                // برای میله‌ها قیمت نهایی فقط با وارد کردن طول مشخص می‌شود
                // Use designProducts (not initialDiameters) to avoid stale empty-diameter closures
                const designDiameterCount = new Set(
                  Object.values(designProducts)
                    .flat()
                    .map((p) => p["Diameter"])
                    .filter((d) => d !== null && d !== undefined)
                ).size;
                const hasMultipleDiameters = designDiameterCount > 1;
                const isRodGroup = ColorProductGroupId === "100605";

                setIsProductAdded(false);
                if (!isColorSelected) {
                  setIsColorSelected(true);
                }

                if (isRodGroup) {
                  setIsPriceSelected(false);
                  setIsDiscPriceSelected(false);
                  setWidth(undefined);
                  latestLenPriceRequestRef.current = null;
                } else if (hasMultipleDiameters) {
                  // Always clear diameter on color change and show min-max until diameter is chosen
                  if (!isActiveColor) {
                    setSelectedDiameter(null);
                    setSelectedIndex(null);
                    setIsWidthSelected(false);
                    setNumberDiameter(null);
                  }
                  if (!isActiveColor || !isWidthSelected) {
                    setIsPriceSelected(false);
                    setIsDiscPriceSelected(false);
                  }
                } else {
                  setIsPriceSelected(true);
                  setIsDiscPriceSelected(true);
                }

                setSearchParams("?Product=" + ProductId);
              }}
            >
              <OverlayContainer
                classNames="Accessories_List_item_color"
                placement="middle"
                children={
                  <div
                    className="Accessories_List_item_colors_list_item_overlay"
                    style={{
                      background:
                        `transparent url(${imgUrl(ColorPhotoPath.trim())}) no-repeat`,
                    }}
                  />
                }
                component={
                  <div className="Accessories_List_item_color_container">
                    <p className="Accessories_List_item_color_text">
                      {pageLanguage === "en" ? ColorEnName : ColorName}
                    </p>
                  </div>
                }
              />
            </li>
          );

          let promiseArr2 = [];
          designProducts[key].forEach((obj, i) => {
            promiseArr2[i] = new Promise((resolve) => {
              let isActiveProduct = obj["ProductId"] === searchParams.get("Product");
              let Diameter = obj["Diameter"];
              setDiameters((prevDiameters) => [...prevDiameters, Diameter]);

              let promiseArr3 = [];
              if (isActiveProduct) {
                let tempPhotosArr = [
                  obj["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl,
                ];
                tempPhotosArr.push(
                  ...obj["Photos"]
                    .map(function(object) {
                      if (object["PhotoTypeId"] !== 4702 && object["PhotoTypeId"] !== 4709) {
                        return object["PhotoUrl"];
                      } else {
                        return undefined;
                      }
                    })
                    .filter((n) => n)
                );
                tempPhotosArr.forEach((el, j) => {
                  promiseArr3[j] = new Promise((resolve) => {
                    tempImgProduct.push(
                      <SplideSlide key={"splide" + ProductId + j} onClick={() => setActiveIndex(j)}>
                        <img
                          className="img-fluid"
                          src={imgUrl(el)}
                          alt={"Image" + j}
                        />
                      </SplideSlide>
                    );
                    tempItemImgProduct.push(
                      <Carousel.Item key={"slide" + obj["ProductId"] + j} className="unselectable">
                        <InnerImageZoom
                          src={imgUrl(el)}
                          zoomSrc={imgUrl(el)}
                          zoomType="hover"
                          hideHint={true}
                        />
                      </Carousel.Item>
                    );
                    resolve();
                  });
                });
              }
              Promise.all(promiseArr3).then(() => {
                resolve();
              });
            });
          });
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setColorsList(tempColorProduct);
        setSplidesList(tempImgProduct);
        setSlidesList(tempItemImgProduct);
      });
    } else {
      setColorsList([]);
      setSlidesList([]);
      setSplidesList([]);
    }
  }
  useEffect(() => {
    renderPageContent();
  }, [activeProduct]);
  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_desc_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_desc_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_accordion_btn_arrow_up img-fluid"
                : "product_accordion_btn_arrow_down img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  const joinWaitingList = () => {
    if (!validateWaitlistEmail(waitlistEmail.trim())) {
      showWaitlistMessage(t("Please enter a valid email"), "error");
      return;
    }

    setWaitlistEmailError("");
    setWaitlistLoading(true);

    axios
      .post(baseURLJoinWaitingList, {
        ProductId: activeProduct["ProductId"],
        Qty: qty,
        Email: waitlistEmail.trim(),
      })
      .then((response) => {
        setWaitlistLoading(false);
        const apiMessage =
          response.data?.Message ||
          response.data?.Errors?.[0]?.Message ||
          "";

        if (response.data?.Success === false || isAlreadyRegisteredMessage(apiMessage)) {
          showWaitlistMessage(
            t("You have already registered for a notification for this item."),
            "error"
          );
          return;
        }

        showWaitlistMessage(t("Your request has been successfully registered"), "success");
      })
      .catch((err) => {
        console.log(err);
        setWaitlistLoading(false);
        const apiMessage =
          err.response?.data?.Message ||
          err.response?.data?.Errors?.[0]?.Message ||
          "";

        if (isAlreadyRegisteredMessage(apiMessage) || err.response?.data?.Success === false) {
          showWaitlistMessage(
            t("You have already registered for a notification for this item."),
            "error"
          );
          return;
        }

        showWaitlistMessage(apiMessage || t("Please enter a valid email"), "error");
      });
  };

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(
        cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402)
      );
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  const addProduct = async (product, count) => {
    setIsProductAdded(true);
    if (isLoggedIn) {
      axios
        .post(
          baseURLAddProduct,
          {},
          {
            headers: authHeader(),
            params: {
              productId: product["ProductId"],
              len: product["len"],
              color: product["Color"],
              width: product["Width"],
              count: count,
            },
          }
        )
        .then((response) => {
          setSideCartObjects(response.data || {});
          updateSideCartSummary(response.data || {});
          setCartCount(response.data?.CartDetails?.length || 0);
          modalHandleShow("cart_modal");
          
          setAddingLoading(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                addProduct(product, count);
              } else {
                addProduct(product, count);
              }
            });
          } else {
            setAddingLoading(false);
          }
        });
    } else {
      let len = product["len"];
      let ProductGroupId = product["ProductGroupId"];
      let ProductId = product["ProductId"];

      if (ProductGroupId === "100605") {
        if (len == null) {
          return;
        }
        try {
          const response = await axios.get(baseURLGetPrice, {
            params: {
              ProductId,
              len,
            },
          });
          product["Price"] = parseInt(response.data);
          product["DiscountedPrice"] = parseInt(response.data);
        } catch (err) {
          console.log(err);
          navigate("/" + pageLanguage);
          return;
        }
      }

      let customPageCart = {};
      product["Count"] = parseInt(count);
      product["len"] = len;
      product["Diameter"] = numberDiameter;
      product["PhotoUrl"] =
        product["Photos"].find((obj) => obj.PhotoTypeId === 4702)?.PhotoUrl || "";

      // بررسی کردن سبد خرید در لوکال استورج
      if (localStorage.getItem("cart") === null) {
        let newCartObj = {};
        let newCartArr = [];
        newCartArr[0] = product;
        newCartObj["drapery"] = newCartArr;
        newCartObj["swatches"] = [];
        localStorage.setItem("cart", JSON.stringify(newCartObj));
        customPageCart = newCartObj;
      } else {
        let cartObj = JSON.parse(localStorage.getItem("cart"));

        if (!cartObj["drapery"] || cartObj["drapery"].length === 0) {
          let newCartArr = [];
          newCartArr[0] = product;
          cartObj["drapery"] = newCartArr;
          localStorage.setItem("cart", JSON.stringify(cartObj));
          customPageCart = cartObj;
        } else {
          let tempProjectContainerIndex = cartObj["drapery"].findIndex(
            (obj) =>
              obj["ProductId"] === product["ProductId"] &&
              obj["len"] === product["len"] &&
              obj["Diameter"] === product["Diameter"]
          );

          // بررسی ProductGroupId برابر با 100606
          if (product["ProductGroupId"] === 100606) {
            if (tempProjectContainerIndex === -1) {
              cartObj["drapery"].push(product);
            } else {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] += parseInt(count);
              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];
              cartObj["drapery"].push(updatedProduct);
            }
          } else {
            if (tempProjectContainerIndex !== -1) {
              cartObj["drapery"][tempProjectContainerIndex]["Count"] += parseInt(count);
              cartObj["drapery"][tempProjectContainerIndex]["Price"] = product["Price"];
              cartObj["drapery"][tempProjectContainerIndex]["DiscountedPrice"] =
                product["DiscountedPrice"];
              let updatedProduct = cartObj["drapery"].splice(tempProjectContainerIndex, 1)[0];
              cartObj["drapery"].push(updatedProduct);
            } else {
              cartObj["drapery"].push(product);
            }
          }

          localStorage.setItem("cart", JSON.stringify(cartObj));
          customPageCart = cartObj;
        }
      }

      setSideCartObjects(customPageCart);
      updateSideCartSummary(customPageCart);
      let cartCount = customPageCart["drapery"]?.length || 0;
      setCartCount(parseInt(cartCount) || 0);
      modalHandleShow("cart_modal");
      setAddingLoading(false);
    }
    setIsProductAdded(false);
  };

  function saveProduct(product, isCompleted, forceAdd) {
    // console.log(product, count);
    setShowToast(false);

    if (isLoggedIn) {
      let tempIndex = userFavorites.findIndex(
        (obj) => obj.ProductId === activeProduct["ProductId"] && obj.IsComplete === isCompleted
      );
      // if(!forceAdd && tempIndex>-1 && (userFavorites[tempIndex]["IsComplete"] || !isCompleted)){
      if (!forceAdd && tempIndex > -1) {
        setToastSave(false);
        setRemovingLoading(true);
        removeProject(userFavorites[tempIndex]["FavoriteProductId"]);
      } else {
        setToastSave(true);
        setSavingLoading(true);
        axios
          .get(baseURLSaveProduct, {
            headers: authHeader(),
            params: {
              id: product["ProductId"],
              pageName: catID,
              isComplete: isCompleted,
            },
          })
          .then((response) => {
            setUserFavorites(response.data || []);
            setSavingLoading(false);

            setShowToast(true);
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  saveProduct(product, isCompleted);
                } else {
                  saveProduct(product, isCompleted);
                }
              });
            } else {
              setSavingLoading(false);
            }
          });
      }
    } else {
      setProductAwaitingLogin([product, isCompleted]);
      dispatch({
        type: ShowLogin2Modal,
      });
    }
  }

  function removeProject(id) {
    axios
      .delete(baseURLDeleteFavorite, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        setUserFavorites(response.data || []);
        setRemovingLoading(false);
        setShowToast(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              removeProject(id);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setRemovingLoading(false);
        }
      });
  }

  const activeColorId = activeProduct["ColorId"];

  useEffect(() => {
    if (Object.keys(designProducts).length > 0) {
      renderPageContent();
    }
  }, [designProducts]);

  useEffect(() => {
    const activeColorProducts = designProducts[activeColorId] || [];
    if (!activeColorProducts.length) {
      return;
    }

    let maxP = -Infinity;
    let minDP = Infinity;

    activeColorProducts.forEach((product) => {
      const price = product["Price"];
      const discountedPrice =
        product["DiscountedPrice"] === null || product["DiscountedPrice"] === undefined
          ? price
          : product["DiscountedPrice"];

      if (typeof price === "number" && price > maxP) {
        maxP = price;
      }
      if (typeof discountedPrice === "number" && discountedPrice < minDP) {
        minDP = discountedPrice;
      }
    });

    setMaxPrice(maxP === -Infinity ? null : maxP);
    setMinDiscountedPrice(minDP === Infinity ? null : minDP);
    setMinDiscountedPrice2(minDP === Infinity ? null : minDP);
  }, [designProducts, activeColorId]);

  useEffect(() => {
    if (catProducts.length) {
      getActiveColorProducts();
    }
    if (isColorSelected) {
      setColorError(false);
    }

    if (!!(isColorSelected || colorsList.length === 1)) {
      setIsPageComplete(true);
    } else {
      setIsPageComplete(false);
    }
  }, [catProducts, searchParams.get("Product"), isColorSelected]);

  useEffect(() => {
    if (slidesList.length) {
      setActiveIndex(0);
    }
  }, [slidesList]);

  useEffect(() => {
    if (isLoggedIn && userFavorites.length && productAwaitingLogin.length) {
      saveProduct(productAwaitingLogin[0], productAwaitingLogin[1], true);
      setProductAwaitingLogin([]);
    }
  }, [userFavorites]);

  useEffect(() => {
    if (splideRef.current) {
      splideRef.current.go(activeIndex);
    }
  }, [activeIndex]);

  useEffect(() => {
    if (pageLanguage !== "") {
      getCatProducts();
      window.scrollTo(0, 0);
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    if (isLoggedIn) {
      getFavorites();
    } else {
      setUserFavorites([]);
    }
  }, [location.pathname, isLoggedIn]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }, [location.pathname]);
  useEffect(() => {
    // Prefer diameters from loaded design products (avoids partial async capture)
    const designDiameters = Object.values(designProducts)
      .flat()
      .map((p) => p["Diameter"])
      .filter((d) => d !== null && d !== undefined);
    if (designDiameters.length > 0) {
      setInitialDiameters(designDiameters);
    }
  }, [designProducts]);

  useEffect(() => {
    const validDiameters = [...new Set(initialDiameters.filter((d) => d !== null))];
    if (validDiameters.length === 1) {
      setSelectedIndex(0);
      setSelectedDiameter(validDiameters[0]);
      setIsWidthSelected(true);
      if (productGroupId !== "100605") {
        setIsPriceSelected(true);
        setIsDiscPriceSelected(true);
      }
    } else if (validDiameters.length > 1) {
      // Multiple diameters: show min-max until user picks one
      if (productGroupId !== "100605" && !isWidthSelected) {
        setIsPriceSelected(false);
        setIsDiscPriceSelected(false);
      }
    }
  }, [initialDiameters, productGroupId, isWidthSelected]);
  let productColor = activeProduct["ColorEnName"];
  let productDiameter = activeProduct["Diameter"];
  useEffect(() => {
    setWidth(undefined);
    activeProduct["len"] = undefined;
    latestLenPriceRequestRef.current = null;
  }, [location, productDiameter, numberDiameter]);

  useEffect(() => {
    axios
    .get(baseURLFreeShipping)
    .then((response) => {
      setFreeShipPrice(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
  }, []);

  let priceMin = activeProduct["DiscountedPrice"];
  let priceMax = activeProduct["Price"];

  const uniqueDesignDiameters = [
    ...new Set(
      Object.values(designProducts)
        .flat()
        .map((p) => p["Diameter"])
        .filter((d) => d !== null && d !== undefined)
    ),
  ];
  // Diameter products: show color min-max until diameter is selected (do not trust stale isPriceSelected)
  const shouldShowPriceRange =
    productGroupId === "100605"
      ? !isPriceSelected
      : uniqueDesignDiameters.length > 1 && !isWidthSelected;

  const uniqueDiameters = [...new Set(initialDiameters)];
  useEffect(() => {
    if (cartUpdated) {
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && modals["cart_modal"] && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, modals, isLoggedIn]);

  useEffect(() => {
    if (sideCartObjects.drapery) {
      setCartCount(sideCartObjects.drapery?.length || 0);
    }
  }, [sideCartObjects]);

  return (
    <div
      className={
        `Product_Item_page_container Ready_made_drapery_page_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }` + ` ${location.pathname.split("/")[2]}`
      }
    >
      <div className="breadcrumb_container dir_ltr">
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{ to: "/" + pageLanguage, className: "breadcrumb_item" }}
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item
            linkAs={Link}
            className="breadcrumb_item"
            linkProps={{
              to: "/" + pageLanguage + "/" + location.pathname.split("/")[2] + "/" + catID,
              className: "breadcrumb_item",
              preventScrollReset: true,
            }}
          >
            {CapitalizeAllWords(catObject["EnTitle"])}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="rmd_product_area_container">
        <div className="rmd_title_mob_container mobile_only">
          <h1 className="rmd_title_mob">
            {pageLanguage === "fa" ? activeProduct["ProductName"] : activeProduct["ProductENName"]}{" "}
            {pageLanguage === "fa"
              ? activeProduct["SewingModelName"]
              : activeProduct["SewingModelEnName"]}
          </h1>
          <h2 className={`rmd_price_mob ${isSoldOut ? "sold_out_price" : ""}`}>
            {isSoldOut
              ? t("Sold Out")
              : shouldShowPriceRange
              ? maxPrice > 0 &&
                (minDiscountedPrice === maxPrice ? (
                  GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                ) : (
                  <>
                    {GetPrice(minDiscountedPrice, pageLanguage, t(""), isTabletOrMobile)}
                    <span style={{ padding: "0 0.3rem" }}>-</span>
                    {GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </>
                ))
              : activeProduct["Price"] > 0 &&
                GetPrice(activeProduct["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
          </h2>
        </div>
        <div className="rmd_left_side">
          <div className="rmd_sticky">
            <div className="rmd_vertical_carousel">
              <Splide
                ref={splideRef}
                options={{
                  height: "44rem",
                  width: "8rem",
                  rewind: false,
                  rewindByDrag: false,
                  direction: "ttb",
                  gap: "1.5rem",
                  type: "slide",
                  perPage: 5,
                  perMove: 1,
                  arrows: false,
                  pagination: false,
                  wheel: false,
                  updateOnMove: false,
                  focus: 0,
                }}
                aria-label="My Favorite Images"
              >
                {splidesList}
              </Splide>
            </div>
            <div className="rmd_images_container mobile_only">
              {!!slidesList.length && (
                <Carousel
                  variant="dark"
                  interval={null}
                  activeIndex={activeIndex}
                  controls={false}
                  touch={true}
                  onSelect={(eventKey) => setActiveIndex(eventKey)}
                >
                  {slidesList}
                </Carousel>
              )}
            </div>
            <div className="rmd_images_container desktop_only">
              <Carousel
                variant="dark"
                interval={null}
                activeIndex={activeIndex}
                controls={false}
                touch={true}
              >
                {slidesList}
              </Carousel>
            </div>
          </div>
        </div>
        <div className="rmd_right_side rmd_right_side-one">
          <div className="rmd_info_container rmd_info_container_one_curtain">
            <div className="rmd_info_title_container desktop_only">
              <h1 className="rmd_info_title title-rods" style={{ display: "flex", gap: "0.1rem" }}>
                <p>
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}
                </p>
                {activeProduct["ProductGroupId"] === "10" && (
                  <p className="rmd_info_title_span">{t("Fabric By The Meter")}</p>
                )}
              </h1>
            </div>
            <>
              {isSoldOut ? (
                <div className="rmd_info_price_container desktop_only">
                  <div className="rmd_info_price sold_out_price">{t("Sold Out")}</div>
                </div>
              ) : shouldShowPriceRange ? (
                <div
                  className="rmd_info_price 1"
                  style={{
                    textDecoration: priceMin < priceMax ? "line-through" : "none",
                  }}
                >
                  {maxPrice > 0 &&
                    (minDiscountedPrice === maxPrice ? (
                      GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                    ) : (
                      <div>
                        <span>
                          {GetPrice(
                            minDiscountedPrice,
                            pageLanguage,
                            t(""),
                            isTabletOrMobile
                          )}
                        </span>
                        <span style={{ padding: "0 0.3rem" }}>-</span>
                        <span>
                          {GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                        </span>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="rmd_info_price_container desktop_only">
                  <div
                    className="rmd_info_price 2"
                    style={{
                      textDecoration: priceMin < priceMax ? "line-through" : "none",
                    }}
                  >
                    {activeProduct["Price"] > 0 &&
                      GetPrice(activeProduct["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </div>
                </div>
              )}
            </>

            <>
              {!isSoldOut &&
                !shouldShowPriceRange &&
                (IsDiscPriceSelected ? (
                  <>
                    {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                      <div className="products_list_item_body_desc_more_desc">
                        {activeProduct["DiscountedPrice"] > 0 &&
                          GetPrice(
                            activeProduct["DiscountedPrice"],
                            pageLanguage,
                            t("TOMANS"),
                            isTabletOrMobile
                          )}
                      </div>
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      fontSize: "1.125rem",
                      marginTop: "-0.5rem",
                    }}
                  >
                    {pageLanguage === "en" ? (
                      <>
                        {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                          <div className="products_list_item_body_desc_more_desc">
                            {activeProduct["DiscountedPrice"] > 0 &&
                              GetPrice(minDiscountedPrice2, pageLanguage, t(""), isTabletOrMobile)}
                          </div>
                        )}
                        {priceMin !== priceMax && <span style={{ color: "#ca6667" }}>-</span>}
                        {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                          <div className="products_list_item_body_desc_more_desc">
                            {activeProduct["DiscountedPrice"] > 0 &&
                              GetPrice(maxPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                          <div className="products_list_item_body_desc_more_desc">
                            {activeProduct["DiscountedPrice"] > 0 &&
                              GetPrice(maxPrice, pageLanguage, t(""), isTabletOrMobile)}
                          </div>
                        )}
                        {priceMin !== priceMax && <span style={{ color: "#ca6667" }}>-</span>}
                        {activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                          <div className="products_list_item_body_desc_more_desc">
                            {activeProduct["DiscountedPrice"] > 0 &&
                              GetPrice(
                                minDiscountedPrice2,
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}

              {!isSoldOut &&
                !shouldShowPriceRange &&
                activeProduct["Price"] !== activeProduct["DiscountedPrice"] && (
                <div className="products_list_item_body_desc_more_desc">
                  {i18n.language === "en" ? (
                    <>
                      {activeProduct["DiscountEnName"]}: {activeProduct["DiscountPercent"]}% off
                    </>
                  ) : (
                    <>
                      {activeProduct["DiscountName"]} :
                      {new Intl.NumberFormat("fa-IR").format(activeProduct["DiscountPercent"])} %
                      تخفیف
                    </>
                  )}
                </div>
              )}
            </>

            <div className="rmd_info_colors_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("Color: ")}</h2>
                {colorError && (
                  <h3 className="rmd_info_little_title error_text">{t("Select a color")}</h3>
                )}
                <h3 className="rmd_info_little_title">
                  {isColorSelected || colorsList.length === 1
                    ? pageLanguage === "fa"
                      ? activeProduct["ColorName"]
                      : capitalizeFirstLetters(activeProduct["ColorEnName"])
                    : ""}
                </h3>
              </div>
              <ul className={colorsList.length > 1 ? "rmd_info_colors_list" : "noDisplay"}>
                {colorsList}
              </ul>
            </div>

            <>
              {Array.isArray(initialDiameters) &&
                initialDiameters.filter((diameter) => diameter !== null).length > 0 && (
                  <div className="rmd_info_size_container">
                    <div className="rmd_info_little_title_container">
                      <h2 className="rmd_info_little_title">{t("Diameter")}:</h2>
                      {isSoldOut && initialDiameters.length > 1 && (
                        <h3 className="rmd_info_little_title error_text">{t("Sold Out")}</h3>
                      )}
                      {!isSoldOut && !isWidthSelected && initialDiameters.length > 1 && (
                        <h3 className={`rmd_info_little_title ${showError ? "error_text" : ""}`}>
                          {t("Select a Diameter")}
                        </h3>
                      )}

                      {!isSoldOut && isWidthSelected && initialDiameters.length > 1 && selectedDiameter && (
                        <h3 className="rmd_info_little_title">
                          {NumToFa(`${selectedDiameter}${t("MM")}`, pageLanguage)}
                        </h3>
                      )}
                      {initialDiameters.length === 1 && (
                        <h3 className="rmd_info_little_title">
                          {NumToFa(`${initialDiameters[0]}${t("MM")}`, pageLanguage)}
                        </h3>
                      )}
                    </div>

                    {initialDiameters.length > 1 && (
                      <ul className={`rmd_info_btn_list${isSoldOut ? " rmd_info_btn_list_disabled" : ""}`}>
                        {Array.from(new Set(initialDiameters.sort((a, b) => a - b))).map(
                          (diameter, index) => (
                            <li
                              key={index}
                              className={`rmd_info_btn_list_item ${
                                index === selectedIndex ? "btnSelected" : ""
                              } ${
                                result[productColor] &&
                                !isProductAdded &&
                                !result[productColor].includes(diameter) &&
                                initialDiameters?.includes(diameter)
                                  ? "crossed"
                                  : ""
                              }`}
                            >
                              <button
                                className="btn"
                                disabled={isSoldOut}
                                onClick={() => {
                                  if (isSoldOut) return;
                                  // برای میله‌ها انتخاب قطر قیمت را تغییر نمی‌دهد و بازه قیمت باقی می‌ماند
                                  const showPriceRange = productGroupId === "100605";
                                  const colorProducts =
                                    designProducts[activeProduct["ColorId"]] || [];
                                  const matchingProduct = colorProducts.find(
                                    (p) => p["Diameter"] === diameter
                                  );
                                  if (!matchingProduct) return;

                                  setSelectedIndex(index);
                                  setSelectedDiameter(diameter);
                                  setIsPriceSelected(!showPriceRange);
                                  setIsDiscPriceSelected(!showPriceRange);
                                  setIsWidthSelected(true);
                                  setNumberDiameter(diameter);
                                  setIsProductAdded(true);

                                  // Switch active product (and URL) to the Color + Diameter variant
                                  if (
                                    matchingProduct["ProductId"] !==
                                    searchParams.get("Product")
                                  ) {
                                    setSearchParams(
                                      "?Product=" + matchingProduct["ProductId"]
                                    );
                                  }
                                }}
                              >
                                {`${diameter}${t("MM")}`}
                              </button>
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </div>
                )}
            </>
            {/* برای طول */}
            {productGroupId === "100605" && (
              <div className={`measure_input_container measure_input_container-rod${isSoldOut ? " sold_out_length" : ""}`}>
                <h1 className="measure_input_label label-length">
                  {t("Length(cm)")}
                  {isSoldOut && (
                    <span className="rmd_info_little_title error_text sold_out_length_label">
                      {t("Sold Out")}
                    </span>
                  )}
                </h1>
                <div className="measure_input_field_container measure_input_field_container-box">
                  <DebounceInput
                    inputRef={(ref) => (inputs.current["len"] = ref)}
                    debounceTimeout={1000}
                    autoComplete="off"
                    placeholder={t("ENTER LENGTH")}
                    disabled={isSoldOut}
                    readOnly={isSoldOut}
                    onKeyDown={(e) => {
                      if (isSoldOut) {
                        e.preventDefault();
                        return;
                      }
                      if (e.keyCode === 13) {
                        if (inputs.current["len"]) {
                          inputs.current["len"].focus();
                        }
                      } else if (
                        !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                        e.keyCode !== 8 &&
                        e.keyCode !== 46 &&
                        e.keyCode !== 37 &&
                        e.keyCode !== 39 &&
                        e.keyCode !== 13
                      ) {
                        e.preventDefault();
                      }
                    }}
                    className={
                      "measure_input" +
                      (width !== undefined && (width < 30 || width > 340)
                        ? " measure_input_err"
                        : "")
                    }
                    type="text"
                    name="width"
                    value={NumToFa(`${width || ""}`, pageLanguage)}
                    onChange={(e) => {
                      if (isSoldOut) return;
                      let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                      newValue = isNaN(newValue) ? "" : newValue;
                      const parsedLen = parseInt(newValue);
                      const digitCount =
                        newValue !== "" && !isNaN(parsedLen) ? String(parsedLen).length : 0;
                      const shouldFetchPrice =
                        (digitCount === 2 || digitCount === 3) &&
                        parsedLen >= 80 &&
                        parsedLen <= 340;

                      if (
                        newValue &&
                        newValue !== "" &&
                        parsedLen >= 80 &&
                        parsedLen <= 340
                      ) {
                        setWidth(parsedLen);
                        activeProduct["len"] = parsedLen;
                        if (shouldFetchPrice) {
                          fetchPriceByLength(parsedLen, activeProduct["ProductId"]);
                        }
                      } else {
                        setIsPriceSelected(false);
                        setIsDiscPriceSelected(false);
                        if (newValue === "" || isNaN(parsedLen)) {
                          setWidth(undefined);
                          activeProduct["len"] = undefined;
                          latestLenPriceRequestRef.current = null;
                        } else {
                          setWidth(parsedLen);
                          activeProduct["len"] = parsedLen;
                        }
                      }
                    }}
                  />
                  <div className="measure_input_postfix">{/* {t("cm_label")} */}</div>
                </div>

                <h2
                  style={{ marginLeft: "0.6rem" }}
                  className={
                    "measure_input_desc" +
                    (width !== undefined && (width < 80 || width > 340)
                      ? " measure_input_desc_err"
                      : "")
                  }
                >
                  {RangeToFa(`80 - 340`, pageLanguage)} {t("cm_label")}
                </h2>
              </div>
            )}

            <div className="rmd_info_qty_container">
              <div className="rmd_info_little_title_container">
                <h2 className="rmd_info_little_title">{t("QTY: ")}</h2>
                {isOverStock && (
                  <h3 className="rmd_info_little_title error_text">
                    {t("We only have {{count}} QTY available.", {
                      count: NumToFa(stockQty, pageLanguage),
                    })}
                  </h3>
                )}
              </div>
              <span className="basket_item_qty">
                <QtyCountFabric
                  qty={qty}
                  setQty={setQty}
                  minQty={1}
                  maxQty={fabricMaxQty}
                  steps={fabricSteps}
                  isReadOnly={true}
                  disabled={isSoldOut}
                  pageLanguage={pageLanguage}
                  NumberToPersianWord={NumberToPersianWord}
                />
              </span>
            </div>

            <div className="rmd_info_btn_container bag_buttons_section_container">
              <div className="join_waitlist_action_block">
                {isWaitlist && showWaitlistEmail && (
                  <input
                    type="email"
                    className="join_waitlist_email_input"
                    placeholder={t("Your email address")}
                    value={waitlistEmail}
                    onChange={(e) => {
                      setWaitlistEmail(e.target.value);
                      if (waitlistEmailError) setWaitlistEmailError("");
                    }}
                  />
                )}
                <button
                  className={`btn add_to_cart`}
                  onClick={() => {
                    if (isSoldOut || isOverStock) return;
                    if (isWaitlist) {
                      if (!showWaitlistEmail) {
                        setShowWaitlistEmail(true);
                        return;
                      }
                      joinWaitingList();
                      return;
                    }
                    if (uniqueDiameters.length > 1) {
                      if (productGroupId === "100608") {
                        if (selectedDiameter === null) {
                          setShowError(true);
                          return;
                        }
                      }
                      if (productGroupId === "100605") {
                        if (selectedDiameter === null) {
                          setShowError(true);
                          return;
                        }
                        if (activeProduct["len"] === undefined) return;
                      }
                      if (productGroupId === "100607") {
                        if (selectedDiameter === null) {
                          setShowError(true);
                          return;
                        }
                      }
                      if (productGroupId === "100606") {
                        if (selectedDiameter === null) {
                          setShowError(true);
                          return;
                        }
                      }
                    }
                    setAddingLoading(true);
                    setShowError(false);
                    addProduct(activeProduct, qty);
                  }}
                  disabled={
                    isSoldOut ||
                    isOverStock ||
                    addingLoading ||
                    savingLoading ||
                    removingLoading ||
                    waitlistLoading
                  }
                >
                  {isSoldOut
                    ? t("Sold Out")
                    : isOverStock
                    ? t("NOT AVAILABLE")
                    : isWaitlist
                    ? waitlistLoading
                      ? t("ADDING...")
                      : t("JOIN WAITLIST")
                    : addingLoading
                    ? t("ADDING...")
                    : t("footer_Add To Cart")}
                </button>
                {isWaitlist && waitlistEmailError && (
                  <div
                    className={`join_waitlist_message ${
                      waitlistMessageType === "success"
                        ? "join_waitlist_message_success"
                        : "join_waitlist_message_error"
                    } ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
                  >
                    {waitlistEmailError}
                  </div>
                )}
              </div>
              <button
                className="save_to_acc white_btn btn"
                onClick={() => {
                  if (isPageComplete) {
                    saveProduct(activeProduct, true);
                  } else {
                    saveProduct(activeProduct, false);
                  }
                }}
                disabled={addingLoading || savingLoading || removingLoading || waitlistLoading}
              >
                <img
                  src={
                    userFavorites.findIndex(
                      (obj) =>
                        obj.ProductId === activeProduct["ProductId"] &&
                        obj.IsComplete === isPageComplete
                    ) > -1
                      ? require("../Images/public/favorite_filled.png")
                      : require("../Images/public/favorite.png")
                  }
                  className="img-fluid"
                  alt=""
                />
                {savingLoading
                  ? t("SAVING...")
                  : removingLoading
                  ? t("REMOVING...")
                  : t("product_Save_To_wishlist")}
              </button>
            </div>
            <div className="rmd_info_desc_container">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <ContextAwareToggleFilters
                    eventKey="0"
                    textOnHide={t("Product Description")}
                    textOnShow={t("Product Description")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DescriptionEn"]
                          : convertToPersian(activeProduct["Description"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <ContextAwareToggleFilters
                    eventKey="1"
                    textOnHide={t("Dimensions")}
                    textOnShow={t("Dimensions")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["DimensionEn"]
                          : convertToPersian(activeProduct["Dimension"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <ContextAwareToggleFilters
                    eventKey="2"
                    textOnHide={t("Materials & Care")}
                    textOnShow={t("Materials & Care")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["MatrialCareEn"]
                          : convertToPersian(activeProduct["MatrialCare"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <ContextAwareToggleFilters
                    eventKey="3"
                    textOnHide={t("Shipping & Returns")}
                    textOnShow={t("Shipping & Returns")}
                  />
                  <Accordion.Body className="product_desc_accordion_dropdown">
                    <div className="product_desc_accordion_dropdown_container">
                      <p>
                        {pageLanguage === "en"
                          ? activeProduct["ShippingReturnEn"]
                          : convertToPersian(activeProduct["ShippingReturn"])}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
        }}
        id="cart_modal"
      >
        <div className="custom_cart_header_desc">{`${
          freeShipPrice - sideCartPrice > 0
            ? `${t("cart_agree_free_ship1")}${
                pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(
                      `${GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}`
                    )
                  : GetPrice(
                      freeShipPrice - sideCartPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )
              }${t("cart_agree_free_ship2")}`
            : `${t("cart_agree_free_ship")}`
        }`}</div>
        <Modal.Header>
          <span className="custom_cart_title">
            {t("My Bag")}{" "}
            <h3>
              (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                : cartCount}
              )
            </h3>
          </span>

          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              sessionStorage.clear();
              // navigate("/" + pageLanguage);
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout" style={{backgroundColor: "#faf9f7"}}>
            <div className="checkout_button_section small_checkout_button_section">
              <div className="small_cart_price_summary">
                {
                  sideCartProductTotal > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail" style={{marginTop:"0.7rem"}}>
                  <h3>{t("PRODUCT TOTAL")}</h3>
                  <h4>
                    {GetPrice(sideCartProductTotal, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </h4>
                </span>
                  )
                }
               
                {sideCartInstallPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("INSTALLATION SERVICES")}</h3>
                    <h4>
                      {GetPrice(sideCartInstallPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                    </h4>
                  </span>
                )}
                {sideCartTransportPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("TRANSPORTATION FEE")}</h3>
                    <h4>
                      {GetPrice(
                        sideCartTransportPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}
                    </h4>
                  </span>
                )}
                {(sideCartHasSwatches ||
                  sideCartProductTotal > 0 ||
                  sideCartInstallPrice > 0 ||
                  sideCartTransportPrice > 0) && (
                  <span className="checkout_payment_price_detail payment_price_detail">
                    <h3>{t("SHIPPING")}</h3>
                    <h4>
                      {freeShipPrice > 0 &&
                      (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                        ? t("FREE")
                        : t("CALCULATED AT CHECKOUT")}
                    </h4>
                  </span>
                )}
              </div>
              <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
              <h3>
                 {freeShipPrice > 0 &&
                (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                 ? t("TOTAL")
               : t("SUBTOTAL")}
              </h3>
                <h4>
                  {GetPrice(
                    isLoggedIn
                      ? sideCartPrice
                      : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                    pageLanguage,
                    t("TOMANS"),
                    isTabletOrMobile
                  )}
                </h4>
              </span>
              <Link className="basket_checkout btn" to={"/" + pageLanguage + "/Basket"}>
                {t("CHECKOUT")}
              </Link>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`measurementsHelp_modal largeSizeModal scroll_on ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
        onHide={() => modalHandleClose("measurementsHelp")}
        scrollable={true}
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <StaticMeasureHelps SewingModelId={activeProduct["SewingModelId"]} />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("measurementsHelp")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="add_to_project_container">
            <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR FAVORITES")}</h2>
            <Link className="add_to_project_btn btn" to={"/" + pageLanguage + "/Account/Favorites"}>
              {t("VIEW FAVORITES")}
            </Link>
            <button
              className="continue_shopping_btn"
              onClick={() => {
                modalHandleClose("add_to_project_modal");
              }}
            >
              {t("CONTINUE SHOPPING")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <ToastContainer
        className={`position_fixed favorite_saved ${toastSave ? "" : "favorite_removed"}`}
        position="top-end"
      >
        <Toast
          onClose={() => setShowToast(false)}
          bg="Light"
          show={showToast}
          delay={5000}
          autohide
        >
          <Toast.Body>
            <div className="favorite_toast_container">
              <div className="favorite_toast_title">
                {toastSave ? t("Added to Favorites") : t("Removed from Favorites")}
              </div>
              <div className="favorite_toast_details">
                <img
                  src={imgUrl(activeProduct["Photos"]?.find(
                    (obj) => obj.PhotoTypeId === 4709
                  )?.PhotoUrl || "")}
                  alt=""
                  className="favorite_toast_img img-fluid"
                />
                <div className="favorite_toast_name">
                  {pageLanguage === "fa"
                    ? activeProduct["ProductName"]
                    : activeProduct["ProductENName"]}{" "}
                  {pageLanguage === "fa"
                    ? activeProduct["SewingModelName"]
                    : activeProduct["SewingModelEnName"]}
                </div>
              </div>
              <div className="button_section">
                <Link className="save_to_fav white_btn " to={"/" + pageLanguage + "/Favorites"}>
                  {t("VIEW FAVORITES")}
                </Link>
              </div>
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default NecessaryOrdering;
